import { IAccountActivationTokenCheckerPayload, IAccountPayload } from '../model/account';
import { useAccountService } from '../service/account';

export const useAccount = () => {
  const { activate, activationTokenChecker, ...restActivationService } = useAccountService();

  async function activateAccount(formData: IAccountPayload) {
    const response = await activate(formData);
    return response;
  }

  async function activationAccountTokenChecker(formData: IAccountActivationTokenCheckerPayload) {
    const response = await activationTokenChecker(formData);
    return response;
  }

  return {
    activateAccount,
    activationAccountTokenChecker,
    ...restActivationService,
  };
};

export default useAccount;
